
import { FSXABaseSection } from 'fsxa-pattern-library'
import { Component } from 'nuxt-property-decorator'
import GptHubIntegration from '../../gpt/GptHubIntegration.vue'
import BaseGridLayout from '../../layouts/BaseGridLayout.vue'

@Component({
  name: 'StGptHubIntegration',
  components: {
    BaseGridLayout,
    GptHubIntegration,
  },
})
export default class StGptHubIntegration extends FSXABaseSection {
}
